export default __webpack_public_path__ + "static/media/ding2_mild_V1.7a8411dd.ogg";